import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./report-form.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./report-form.component.scss?ngResource";
import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { UcFirstPipe } from "ngx-pipes";
import { SelectedApplicationService } from "../../../services/selected-application/selected-application.service";
import { ReportCriteriaConst } from "../../report-form/report-criteria-form/report-criteria-constants";
import { ReportTypeFormComponent } from "../../report-form/report-type-form/report-type-form.component";
import { ReportService } from "../../report-form/report.service";
import { SharedConstants } from "../../../constants/shared.constants";
import { AppControllerService } from "../../../../app-controller.service";
import { CRUDOperation } from "../../../models/crud-operation-enum.model";
import { AlertType } from "../../../models/alert";
import { AutoUnsub } from "../../../decorators/autounsub.decorator";
let ReportFormComponent = class ReportFormComponent extends ReportTypeFormComponent {
    sevice;
    formBuilder;
    appController;
    changeDetectorRefs;
    datePipe;
    ucFirst;
    selectedApplicationService;
    inReportName;
    inReportGoup;
    jobID;
    componentType;
    uploadReport = ReportCriteriaConst.UPLOAD_REPORT;
    uploadReportCtrl = ReportCriteriaConst.UPLOAD_REPORT_CONTOL;
    componentTypeCtrl = ReportCriteriaConst.COMPONENT_TYPE_CONTOL;
    criteriaFieldValueError = SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION;
    jobIdCtrl = ReportCriteriaConst.JOB_ID_CONTOL;
    application;
    selectedApplicationSubscription;
    getReportGroupsByGroupSubscription;
    getReportGroupByGroupAndReportNameSubscription;
    constructor(sevice, formBuilder, appController, changeDetectorRefs, datePipe, ucFirst, selectedApplicationService) {
        super(formBuilder, appController, changeDetectorRefs, sevice, ucFirst);
        this.sevice = sevice;
        this.formBuilder = formBuilder;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.datePipe = datePipe;
        this.ucFirst = ucFirst;
        this.selectedApplicationService = selectedApplicationService;
    }
    // public reportCriteriaFrm(): FormGroup {
    //   const form = this.formSetup();
    //   let control: FormControl;
    //   control = this.preparValidation();
    //   form.addControl(ReportCriteriaConst.CRITERIA_FIELD_VALUE_CONTROL, control);
    //   if (this.reportCriteriaRow.IsApplicationId) {
    //     form
    //       .get(ReportCriteriaConst.CRITERIA_FIELD_VALUE_CONTROL)
    //       .setValue(this.application.appId);
    //   }
    //   if (this.reportCriteriaRow.IsJobId) {
    //     form
    //       .get(ReportCriteriaConst.CRITERIA_FIELD_VALUE_CONTROL)
    //       .setValue(this.jobID);
    //   }
    //   return form;
    // }
    pageInit() {
        this.subscribeToSelectedApplication();
        this.seDefaultValues();
    }
    initializeDropdowmn() {
        if (this.inReportName) {
            this.getReportByGroupByReportId();
        }
        else if (!this.inReportName && this.inReportGoup) {
            this.getReportByGroup();
        }
        else {
            super.initializeDropdowmn();
        }
    }
    // protected setReportCriteria(reportCriteriaRow: IReportCriteria): void {
    //   let formGroup: FormGroup;
    //   if (reportCriteriaRow.CriteriaFieldLabel) {
    //     reportCriteriaRow.CriteriaFieldLabel = this.ucFirst.transform(
    //       reportCriteriaRow.CriteriaFieldLabel.toLowerCase()
    //     );
    //   }
    //   if (this.checkIfRowIsApplicationID(reportCriteriaRow)) {
    //     reportCriteriaRow.IsApplicationId = true;
    //   }
    //   if (this.checkIfRowIsJobID(reportCriteriaRow)) {
    //     reportCriteriaRow.IsJobId = true;
    //   }
    //   this.reportCriteriaRow = reportCriteriaRow;
    //   formGroup = this.reportCriteriaFrm();
    //   this.reportCriteria.push(formGroup);
    // }
    subscribeToSelectedApplication() {
        this.reportGroupNameMap = new Map();
        this.initializeDropdowmn();
        this.selectedApplicationSubscription =
            this.selectedApplicationService.$selectedApplication
                .subscribe({
                next: (app) => {
                    this.application = app;
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage(ReportCriteriaConst.CRITERIA_TITLE, error, CRUDOperation.Get);
                }
            });
    }
    seDefaultValues() {
        this.reportTypeForm.get(this.uploadReportCtrl).setValue(true);
        this.reportTypeForm.get(this.componentTypeCtrl).setValue(this.componentType);
        this.reportTypeForm.get(this.jobIdCtrl).setValue(this.jobID);
    }
    // private checkIfRowIsApplicationID(
    //   reportCriteriaRow: IReportCriteria
    // ): boolean {
    //   if (!reportCriteriaRow || !reportCriteriaRow.CriteriaName) {
    //     return false;
    //   }
    //   const value = ReportManagerConstant.DefaultApplicationIdFields.findIndex(
    //     (f) => f === reportCriteriaRow.CriteriaName.toLowerCase().replace(" ", "")
    //   );
    //   return value > -1;
    // }
    // private checkIfRowIsJobID(reportCriteriaRow: IReportCriteria): boolean {
    //   if (!reportCriteriaRow || !reportCriteriaRow.CriteriaName) {
    //     return false;
    //   }
    //   const value = ReportManagerConstant.DefaultJobdFields.findIndex(
    //     (f) => f === reportCriteriaRow.CriteriaName.toLowerCase().replace(" ", "")
    //   );
    //   return value > -1;
    // }
    getReportByGroup() {
        this.getReportGroupsByGroupSubscription =
            this.sevice.getReportGroupsByGroup(+this.appController.selectedModuleID, this.inReportGoup)
                .subscribe({
                next: (response) => {
                    if (!response || !response.value || response.value.length === 0) {
                        this.appController.showMessage(ReportCriteriaConst.INVALID_REPORT_GROUP_NAME, AlertType.Warning);
                        return;
                    }
                    this.reportList = response.value;
                    this.setReportGrouNames();
                    this.reportGroup.setValue(this.inReportGoup);
                    this.getReport();
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage(this.constructor.name, error, CRUDOperation.Get);
                }
            });
    }
    getReportByGroupByReportId() {
        this.getReportGroupByGroupAndReportNameSubscription =
            this.sevice.getReportGroupByGroupAndReportName(+this.appController.selectedModuleID, this.inReportName)
                .subscribe({
                next: (response) => {
                    if (!response || !response.value || response.value.length === 0) {
                        this.appController.showMessage(ReportCriteriaConst.INVALID_REPORT_NAME, AlertType.Warning);
                        return;
                    }
                    this.reportList = response.value;
                    this.setReportGrouNames();
                    this.reportId.setValue(this.reportList[0].id);
                    this.inReportGoup = this.reportList[0].groupName;
                    this.reportGroup.setValue(this.reportList[0].groupName);
                    this.getReport();
                    this.onSelectReport();
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage(this.constructor.name, error, CRUDOperation.Get);
                }
            });
    }
    static ctorParameters = () => [
        { type: ReportService },
        { type: FormBuilder },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: DatePipe },
        { type: UcFirstPipe },
        { type: SelectedApplicationService }
    ];
    static propDecorators = {
        inReportName: [{ type: Input }],
        inReportGoup: [{ type: Input }],
        jobID: [{ type: Input }],
        componentType: [{ type: Input }]
    };
};
ReportFormComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-report-form",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ReportFormComponent);
export { ReportFormComponent };
